import api from './api';

export const getSitasUsers = (params) => api.get('/api/sitas/users', { params });
export const getSitasUserRoute = (userId, params) => api.get(`/api/sitas/users/${encodeURIComponent(userId)}/route`, { params });
export const getSitasBins = (params) => api.get('/api/sitas/bins', { params });
export const exportSitasUsers = (params) => api.get('/api/sitas/users/export', { params, responseType: 'blob' });
export const exportSitasBins = (params) => api.get('/api/sitas/bins/export', { params, responseType: 'blob' });
export const getSitasGeofences = () => api.get('/api/sitas/geofences');
export const saveSitasGeofence = (data) => api.post('/api/sitas/geofences', data);
export const deleteSitasGeofence = (id) => api.delete(`/api/sitas/geofences/${encodeURIComponent(id)}`);
export const getSitasGeofenceEvents = (params) => api.get('/api/sitas/geofences/events', { params });

